// extracted by mini-css-extract-plugin
export default {"toggle":"JaymarStudioForm_toggle__CRmfT"};